module.exports = __webpack_public_path__ + "resources/rank_right.90881837e100c572.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/label/img/rank_right.png
// module id = 538
// module chunks = 0 1 2 3